import React, { useMemo, useState } from 'react'
import { HeroBannerData } from '@/services/RecommendedBannerService/types'
import { PageDataContext, PageModel } from '@/services/RenderService'
import { ReactFCC } from '@/types/react'
import { Maybe } from '@/utils/types'

interface WatchPageContextProp {
  pageDataContext: Maybe<PageDataContext>
  page: Maybe<PageModel>
  children: React.ReactNode
}

interface WatchPageContextType {
  pageDataContext: Maybe<PageDataContext>
  page: Maybe<PageModel>
  currentBanner: HeroBannerData | null
  setCurrentBanner: React.Dispatch<React.SetStateAction<HeroBannerData | null>>
}

const WatchPageContext = React.createContext<WatchPageContextType>({
  pageDataContext: undefined,
  page: undefined,
  currentBanner: null,
  setCurrentBanner: () => {},
})

export const WatchPageContextProvider: ReactFCC<WatchPageContextProp> = ({ children, pageDataContext, page }) => {
  const [currentBanner, setCurrentBanner] = useState<HeroBannerData | null>(null)

  const value = useMemo(() => {
    return {
      pageDataContext,
      page,
      currentBanner,
      setCurrentBanner,
    }
  }, [pageDataContext, page, currentBanner])

  return <WatchPageContext.Provider value={value}>{children}</WatchPageContext.Provider>
}

export function useWatchPageContext() {
  return React.useContext(WatchPageContext)
}
